export default {
  TitleDetail: "Thu hồi tài sản",
  RecoveryInfoTitle: "Thông tin thu hồi tài sản",
  DateRecovery: "Ngày thu hồi",
  ReasonRecovery: "Lý do thu hồi",
  Localtion: "Vị trí địa lý ",
};
